export default __webpack_public_path__ + "static/media/BOB_0046.726df64c.JPG";